import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const MenuIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 19 15", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    transform="translate(-336.000000, -71.000000)"
                    fill="#33006E"
                    fillRule="nonzero"
                >
                    <g transform="translate(337.000000, 72.000000)">
                        <polygon points="17.6 5.9 17.6 7.1 -0.6 7.1 -0.6 5.9"></polygon>
                        <polygon points="17.6 11.9 17.6 13.1 -0.6 13.1 -0.6 11.9"></polygon>
                        <polygon points="17.6 -0.1 17.6 1.1 -0.6 1.1 -0.6 -0.1"></polygon>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
